import { checkIsInternalSourcing } from "../../util/constantUtility";
import * as axiosService from "../axiosService";


export const getBidList = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Bid/GetMyBidList`,payload);
};

export const getBidFiltersData = (bidType) => {
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Bid/GetBidFiltersData?type=${bidType}`);
};

export const getAssetAllocation = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Bid/GetAssetAllocation`,payload);
};

export const saveAcceptBid = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Bid/AcceptBid`,payload);
};

export const saveAssetAllocation = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Bid/AssetAllocation`,payload);
};

export const saveBookNow = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Bid/BookNow`,payload);
};

export const getBidsDetails = (bidId,userRole,bidTypeValue,bidSequenceValue) => {
    const queryParams = [];
    queryParams.push(`InquiryId=${bidId}`);
    if (checkIsInternalSourcing(userRole) && bidSequenceValue && bidSequenceValue > 0) {
        if (bidTypeValue) {
        queryParams.push(`type=${bidTypeValue}`);
        }
        if (bidSequenceValue) {
            queryParams.push(`bidSequence=${bidSequenceValue}`);
        }
       }
       const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Bid/GetBidDetailsByInquiry${queryString}`);
};

export const getAssignmentFleetList = (payload) => {
    const queryParams = [];
    if (payload.loadId) {
        queryParams.push(`loadId=${payload.loadId}`);
    }
    if (payload.supplierId) {
        queryParams.push(`supplierId=${payload.supplierId}`);
    }
    if (payload.assetPlateNumber) {
        queryParams.push(`assetPlateNumber=${payload.assetPlateNumber}`);
    }
    if(payload.sortBy){
        queryParams.push(`sortBy=${""}`);
    }
    if (payload.sortOrder) {
        queryParams.push(`sortOrder=${payload.sortOrder}`);
    }
    if (payload.orderNumber) {
        queryParams.push(`orderNumber=${payload.orderNumber}`);
    }

    if (payload.isNewBid) {
        queryParams.push(`isNewBid=${payload.isNewBid}`);
    }

    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Bid/GetAssignmentFleetList${queryString}`);
};

export const getSearchTruck = (payload) => {
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Truck/SearchTruck?assetPlateNumber=${payload?.assetPlateNumber}&supplierId=""`);
};


export const getSearchDriver = (driverName) => {
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Driver/SearchDriver?name=${driverName}`);
};

export const getSearchSupplier = (payload) => {
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Supplier/SearchSuppliersListByInternalSourcer?searchText=${payload?.searchText}`);
};


export const getAllTruck = (payload) => {
    const queryParams = [];
       queryParams.push(`type=Truck`);
        if (payload?.supplierId) {
        queryParams.push(`supplierId=${payload?.supplierId}`);
        }
        if (payload?.loadId) {
            queryParams.push(`loadId=${payload?.loadId}`);
        }
        if (payload?.isNewBid) {
            queryParams.push(`isNewBid=${payload?.isNewBid}`);
        }
       const queryString = queryParams?.length > 0 ? `?${queryParams.join('&')}` : '';
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Bid/GetAssignmentRecommendedFleetList${queryString}`);
};


export const getAllDriver = (payload) => {
    const queryParams = [];
       queryParams.push(`type=Driver`);
        if (payload?.supplierId) {
        queryParams.push(`supplierId=${payload?.supplierId}`);
        }
        if (payload?.loadId) {
            queryParams.push(`loadId=${payload?.loadId}`);
        }
        if (payload?.isNewBid) {
            queryParams.push(`isNewBid=${payload?.isNewBid}`);
        }
       const queryString = queryParams?.length > 0 ? `?${queryParams.join('&')}` : '';
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Bid/GetAssignmentRecommendedFleetList${queryString}`);
};

export const getAllSupplierList = (payload) => {
    const queryParams = [];
    if (payload.loadId) {
        queryParams.push(`loadId=${payload.loadId}`);
    }
    if (payload.searchText) {
        queryParams.push(`searchText=${payload.searchText}`);
    }
    if (payload.pageNumber) {
        queryParams.push(`pageNumber=${payload.pageNumber}`);
    }
    if (payload.pageSize) {
        queryParams.push(`pageSize=${payload.pageSize}`);
    }
    if (payload.sortOrder) {
        queryParams.push(`sortOrder=${payload.sortOrder}`);
    }
    if (payload.orderNumber) {
        queryParams.push(`orderNumber=${payload.orderNumber}`);
    }
    if(payload.bidSequence && payload.bidSequence > 0){
       queryParams.push(`bidSequence=${payload.bidSequence}`);
    }
    if(payload.type){
       queryParams.push(`type=${payload.type}`);
    }

    queryParams.push(`sortBy=name`);
    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Bid/GetAssignmentSupplierList${queryString}`)
};

export const CheckAvailableSourcingCount = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Bid/CheckAvailableSourcingCount`,payload);
};

export const getVendorContractRateList = (payload) => {
    const queryParams = [];

    if (payload.loadId) {
        queryParams.push(`loadId=${payload.loadId}`);
    }
    if (payload.supplierId) {
        queryParams.push(`supplierId=${payload.supplierId}`);
    }

    const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

   return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Bid/GetVendorContractRateList${queryString}`);
};

export const getMyBidListIS = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Bid/GetMyBidListIS`,payload);
};

export const saveAssetAllocationIS = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Bid/AssetAllocationIS`,payload);
};

